import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { AuthenticationService } from '../services/authentication.service';
import { ApiService } from '../services/api.service';
import { TranslateService } from '@ngx-translate/core';
var LoginComponent = (function () {
    function LoginComponent(authService, activatedRoute, router, translate, apiService) {
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.translate = translate;
        this.apiService = apiService;
        this.errorMessage = null;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        localStorage.clear();
        this.activatedRoute.params.subscribe(function (params) {
            _this.errorMessage = params.msg || null;
        });
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        this.errorMessage = null;
        if (_.isNil(this.username) || _.isNil(this.password)) {
            this.errorMessage = this.translate.instant('PROFILE.LIST.COMPLETE');
            return;
        }
        this.authService.login(this.username, this.password).subscribe(function (user) {
            var token = _.get(user, 'token');
            localStorage.clear();
            localStorage.setItem('currentUser', token);
            _this.authService.updateUserInfo(user);
            if (token != null) {
                var requireToChangePassword = _.get(user, 'require_to_change_password');
                if (requireToChangePassword) {
                    localStorage.setItem('require_to_change_password', 'true');
                    _this.router.navigate(['/profile', 'password']);
                }
                else if (_this.authService.isAccountant()) {
                    _this.router.navigate(['/search']);
                }
                else {
                    _this.router.navigate(['']);
                }
            }
            _this.sniff('LOGIN', _this.username);
        }, function (error) {
            _this.errorMessage = _this.apiService.getErrorMessage(error);
        });
    };
    LoginComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'HOME',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.ts.pre-build-optimizer.js